export default __webpack_public_path__ + "media/CopilotStudio.78a85fb2.svg";